import React, { useEffect } from "react";
import { Container, Row, Col, Nav, Navbar, Button, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getInventoryItems, getInventoryPurchase, getInventorySupplier, handleError } from "../../../../redux/inventory";
import { handleLogout } from "../../../../redux/authentication";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

const AdminPage = () => {
  const itemsList = useSelector((state) => state.itemsList);
  const auth = useSelector((state) => state.authentication);
  const dispatch = useDispatch();
  const { userData } = auth;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (userData.token) {
      dispatch(getInventoryPurchase({ token: userData.token, branch: userData.branch }));
      dispatch(getInventorySupplier({ token: userData.token, branch: userData.branch }));
      dispatch(getInventoryItems({ token: userData.token, branch: userData.branch }));
    }
  }, [userData.token]);

  useEffect(() => {
    if (itemsList?.error && itemsList.error.message === "Request failed with status code 403") {
      dispatch(handleError());
      dispatch(handleLogout());
      navigate("/");
    }
  }, [itemsList]);

  // Dynamic Navigation Items Array
  const navLinks = [
    { label: "Accounts", path: "/accounts" },
    { label: "Purchase", path: "/phmcy-admin/purchase" },
    { label: "Purchase Returns", path: "/phmcy-admin/rtn-purchase" },
    { label: "Wholesale Invoice", path: "/wholesale-invoice" },
    { label: "Wholesale Invoice View", path: "/wholesale-invoice-list" },
    { label: "Suppliers", path: "/phmcy-admin/suppliers" },
    { label: "Stock Management", path: "/phmcy-admin/sku" },
    { label: "Procedures", path: "/phmcy-admin/procedures" },
    { label: "Out - Patient", path: "/bill-tabs" },
    { label: "In - Patient", path: "/phmcy-admin/ip" },
    { label: "Consumption", path: "/phmcy-admin/consume" },
    { label: "Patient Registration", path: "/crm-clt" },
    { label: "Reports", path: "/phmcy-admin/sales" },
    { label: "Removed Items", path: "/phmcy-admin/removed-items" },
  ];

  const handleLogoutClick = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("srchData");
    sessionStorage.removeItem("prescriptionHistory");
    sessionStorage.removeItem("rights");
    dispatch(handleLogout());
    navigate("/cri-crm");
  };

  return (
    <Container fluid className="px-3 py-2 min-vh-100 d-flex flex-column">
      {/* Header Bar */}
      <Card
        className="mb-2 shadow-sm border-0 text-white"
        style={{
          backgroundColor: "rgba(50, 0, 100, 0.9)",
          borderRadius: "6px",
        }}
      >
        <Card.Body className="py-2 px-3">
          <Row className="align-items-center">
            <Col md={3}>
              <h5 className="mb-0 fw-bold">Pharmacy Management</h5>
            </Col>
            <Col md={6} className="text-center">
              <span className="text-light fs-6">
                <strong>User:</strong> {userData.user}
              </span>
            </Col>
            <Col md={3} className="d-flex justify-content-end gap-2">
              {(userData.rights === "Admin" || userData.rights === "Manager") && (
                <Button variant="outline-light" size="sm" onClick={() => navigate("/crm-clt")}>
                  Back
                </Button>
              )}
              <Button variant="danger" size="sm" onClick={handleLogoutClick}>
                Log Out
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Top Navigation Menu Bar */}
      <Navbar bg="light" expand="lg" className="px-2 py-1 mb-3 rounded border shadow-sm sticky-top" style={{ zIndex: 100 }}>
        <Nav className="w-100 d-flex flex-wrap gap-1">
          {navLinks.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <Button
                key={index}
                variant={isActive ? "primary" : "outline-secondary"}
                size="sm"
                className="py-1 px-2 fw-medium"
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Button>
            );
          })}
        </Nav>
      </Navbar>

      {/* Main Dynamic Content Window */}
      <div className="flex-grow-1 w-100 bg-white p-3 rounded shadow-sm border" style={{ minHeight: "calc(100vh - 160px)", height: "auto" }}>
        <Outlet />
      </div>
    </Container>
  );
};

export default AdminPage;